import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  Notification,
  NotificationsFilter
} from '../../lib/types/models/notification/notification'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getNotifications = (input: PaginationRequest<NotificationsFilter>) => {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.notifications.getAll.url, null), input))
    .get<PaginationResponse<Notification>>()
}
